import { useEffect, useState } from 'react';
import Logo from './Logo';
import { Link, useRouter } from '../hooks/useRouter';
import { NAV } from '../content/copy';

export default function Nav({ theme, onContact }) {
  const { path } = useRouter();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [path]);

  return (
    <header className={`bv-nav ${scrolled ? 'is-scrolled' : ''} ${open ? 'is-open' : ''}`}>
      <div className="bv-nav-inner">
        <Link to="/" className="bv-nav-logo" aria-label="Black Vanilla home">
          <Logo size={34} theme={theme === 'dark' ? 'dark' : 'light'} />
        </Link>

        <nav className="bv-nav-links" aria-label="Primary">
          {NAV.map((item) => (
            <Link key={item.path} to={item.path} className="bv-nav-link">
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="bv-nav-actions">
          <button type="button" className="bv-btn bv-btn-solid bv-nav-cta" onClick={onContact}>
            Contact us <span aria-hidden="true">→</span>
          </button>
          <button
            type="button"
            className="bv-hamburger"
            aria-expanded={open}
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? '✕' : '☰'}
          </button>
        </div>
      </div>

      <div className={`bv-mobile-nav ${open ? 'open' : ''}`}>
        {NAV.map((item) => (
          <Link key={item.path} to={item.path} className="bv-mobile-link">
            {item.label}
          </Link>
        ))}
        <div className="bv-mobile-cta">
          <button type="button" className="bv-btn bv-btn-solid bv-btn-block" onClick={() => { onContact(); setOpen(false); }}>
            Contact us <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>
    </header>
  );
}
